export default "__VITE_ASSET__DP6P7v24__"